import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FAQSection />
        <FeaturesSection />
        <RankingSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}